/* eslint-disable react/destructuring-assignment -- Will make the code unnecessarily complex */
import { VideoPlayer } from "@circle-react-shared/MediaPlayer/VideoPlayer";
import { useMediaConfig } from "@circle-react-shared/MediaPlayer/VideoPlayer/hooks/useMediaConfig";
import type { TranscriptsPlayerProps } from "@circle-react-uikit/TranscriptsPlayer/TranscriptsPlayerComponent";
import { TranscriptsPlayerComponent } from "@circle-react-uikit/TranscriptsPlayer/TranscriptsPlayerComponent";

export const TranscriptsPlayerWrapper = (props: TranscriptsPlayerProps) => {
  const isVideoFile = props.type.toLowerCase().startsWith("video/");

  const { posterUrl, isDownloadable, mediaTranscriptId } = useMediaConfig({
    signedId: props.signedId,
    posterUrl: props.poster,
    isDownloadable: props.isDownloadable,
    mediaTranscriptId: props.mediaTranscriptId,
  });

  if (isVideoFile)
    return (
      <VideoPlayer
        src={props.src}
        contentType={props.type}
        mediaTranscoding={props.mediaTranscoding}
        mediaTranscriptId={mediaTranscriptId}
        downloadable={isDownloadable}
        downloadUrl={props.downloadUrl}
        posterUrl={posterUrl}
        chaptersUrl={props.chaptersUrl}
        previewThumbnailsUrl={props.previewThumbnailsUrl}
        signedId={props.signedId}
        variants={props.variants}
        onProgress={props.onProgress}
        preload={props.preload}
      />
    );

  return <TranscriptsPlayerComponent {...props} />;
};
